import ButtonAnchor from "../basic/ButtonAnchor";

const PlankSpin = () => {
  return (
    <main>

      <section className="articles">

        <article className="left-image">

            <img src="/images/games/plankspin_appicon.png" alt="Plank Spin Appicon" />
            <div>

              <h3 className="plank-spin">Plank Spin</h3>
              <p>
                My second game, Plank Spin, is a unique casual game where you spin your plank as many times as possible while in the air to get points. This game is about precision and timing, spin too much or too little and you'll hit the barrier! Upgrade your plank to progress further!
              </p>
              <ButtonAnchor className="plank-spin" to="https://apps.apple.com/gb/app/plank-spin/id1602811769" text="Download for iOS" icon_path="/images/icons/appstore-icon.svg" alt_text="App Store Icon" />
            
            </div>
            
          </article>

        <article>
          <h3 className="plank-spin">Play it now in your browser!</h3>
          <p>
            Plank Spin can be played now in your browser! This version is not supported, and any minor bugs will not be fixed. Please still let me know (<a href="mailto:minibonzogames@gmail.com" className="plank-spin">minibonzogames@gmail.com</a>) and known bugs will be posted here.
          </p>
          <ButtonAnchor className="plank-spin" to="/play/plank-spin/index.html" text="Click here to play now!" icon_path="/images/icons/play-icon.svg" alt_text="Play Button" />
        </article>

      </section>
      
    </main>
  );
}

export default PlankSpin;